module.exports = __webpack_public_path__ + "img/logo tu incentivo BRIDGESTONE a final-01.e3866123.png";